//@flow
import { useGlobalContext } from '~/core/context'

type usePermissionsOptions = {
  enabled?: boolean
}

const usePermissions = (resource: string, options?: usePermissionsOptions = {}) => {
  const { permissions } = useGlobalContext()

  // Provide backward compatibility
  if (options.enabled === false) {
    return {
      readable: ['*'],
      writable: ['*'],
      executable: ['*']
    }
  }

  return permissions.reduce(
    (acc, permissionString) => {
      const [permission, entity, entityId = '*'] = permissionString.split(':')
      if (entity === resource) {
        if (permission.includes('r')) {
          acc.readable.push(entityId)
        }
        if (permission.includes('w')) {
          acc.writable.push(entityId)
        }
        if (permission.includes('x')) {
          acc.executable.push(entityId)
        }
      }

      return acc
    },
    {
      readable: [],
      writable: [],
      executable: []
    }
  )
}

export { usePermissions }
